module.exports = __webpack_public_path__ + "flyer_background_floral_frame_black_106-36b909b70ef6972f507222b24e3aa1a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_floral_frame_black_106.jpg
// module id = 1644
// module chunks = 1